<template>
    <div v-if="listUrl" class="row mp-search-tabs">
        <div class="col-12">
            <ul class="nav nav-tabs">
                <li class="nav-item">
                    <a :href="listUrl" class="nav-link">{{ translations.records }}</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link active" href="#">{{ translations.search }}</a>
                </li>
            </ul>
        </div>
    </div>

    <form class="row mp-search-filter" @submit="search($event)">
        <div class="col-12 col-sm-3">
            <input v-model="query" class="form-control">
        </div>
        <div class="col-12 col-sm-3">
            <input :value="translations.toSearch" class="btn btn-primary" type="submit">
        </div>
    </form>
    <article v-for="item in results.data" :key="item.id" class="item">

        <div class="row">
            <div class="col-4 col-sm-2">
                <img :alt="item.recordName" :src="getImagePath(item.recordId, item.number)" class="img-fluid">
            </div>

            <div class="col-8 col-sm-7">
                <span v-html="item.text"></span>
                <div class="link d-none d-sm-block">
                    <a :href="getRecordUrl(item.recordId, item.number)" class="btn btn-secondary">Seite öffnen</a>
                </div>
            </div>

            <div class="col-12 col-sm-3">
          <span class="edition">
            <a :href="getRecordUrl(item.recordId, 1)" target="_blank"><strong>{{ translations.record }}:</strong> 
              {{ item.recordName }}</a>
          </span> <span class="page">
            <a :href="getRecordUrl(item.recordId, item.number)" target="_blank">
              <strong>{{ translations.page }}:</strong> {{ item.number }}
            </a>
          </span>
            </div>
        </div>
    </article>
    <div class="paging">
        <nav aria-label="Page navigation">
            <md-pager :pageNumber="pageNumber" :total-pages="totalPages" @update="changePage"></md-pager>
        </nav>
    </div>
</template>

<script>
import axios from 'axios';
import MdPager from './Components/Pager.vue';

export default {
    components: {
        MdPager
    },
    props: {
        pageSize: Number,
        showFilter: Boolean,
        showPaging: Boolean,
        page: Number,
        listUrl: String,
        viewerUrl: String
    },
    data() {
        return {
            query: '',
            totalPages: 0,
            limit: 50,
            offset: 0,
            results: {
                data: [],
                total: 0
            }
        }
    },
    mounted() {
        this.limit = this.pageSize;
        this.offset = (this.page - 1) * this.limit;
    },
    methods: {
        search(e) {
            if (e) {
                e.preventDefault()
            }
            let self = this;
            if (self.query === '') {
                return;
            }
            axios.get(`/umbraco/mdpaper/page/search?from=&to=&query=${self.query}&limit=${self.limit}&offset=${self.offset}`).then(res => {
                self.results = res.data;
                self.totalPages = Math.ceil(self.results.total / self.limit);
            });
        },
        getImagePath(recordId, pageNumber) {
            return `/umbraco/mdpaper/page/GetJpgByPageNumber?recordId=${recordId}&pageNumber=${pageNumber}`;
        },
        getRecordUrl(recordId, pageNumber) {
            return `${this.viewerUrl}?rid=${recordId}&p=${pageNumber}`;
        },
        changePage(pageNumber) {
            this.offset = (pageNumber - 1) * this.limit;
            this.search();
        }
    },
    computed: {
        translations() {
            return multiPaper.listTranslations;
        },
        pageNumber() {
            if (this.offset === 0) {
                return 1;
            }
            return this.offset / this.limit + 1;
        },
        filterQuery() {
            let returnValue = '';
            if (this.year !== '' && this.month !== '') {
                let daysInMonth = new Date(this.year, this.month, 0).getDate();
                returnValue = `date:[${this.year}-${this.month}-01T00:00:00Z TO ${this.year}-${this.month}-${daysInMonth}T00:00:00Z]`;
            } else if (this.year !== '' && this.month === '') {
                returnValue = `date:[${this.year}-01-01T00:00:00Z TO ${this.year}-12-31T00:00:00Z]`;
            }
            if (this.filter !== '') {
                returnValue += `AND ${this.filter}`;
            }
            return returnValue;
        },
        years() {
            let years = [];
            let actualYear = new Date().getFullYear();
            for (let year = actualYear; year >= 1980; year--) {
                years.push(year);
            }
            return years;
        }
    }
}
</script>